export default {
  // PROD/DEV URLS
  PROD_BASE_URL: "getproductive.net",
  PROD_PHP_URL: "https://getproductive.net/php",
  DEV_PHP_URL: "http://localhost/php-dev/get-productive",

  // SCALE COLORS
  SCALE_COLOR_ONE: "rgb(156, 212, 156)",
  SCALE_COLOR_TWO: "rgb(190, 212, 156)",
  SCALE_COLOR_THREE: "rgb(212, 208, 156)",
  SCALE_COLOR_FOUR: "rgb(212, 186, 156)",
  SCALE_COLOR_FIVE: "rgb(212, 156, 156)",
  SCALE_COLOR_NEUTRAL: "rgb(211, 211, 211)",
  SCALE_COLOR_NEGATIVE_COST: "rgb(0, 209, 28)",
};
